module.exports = __webpack_public_path__ + "img/a41becbfff22d7444eeead463c52ab13.png";